import { useNavigate, useSearchParams } from "react-router-dom";

import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { useUserProductsPos } from "~/api/products/hooks/use-user-products";
import { useUserBalance } from "~/hooks/use-user-balance";
import { useBasketContext } from "~/providers/store/basket/context";
import { useSplitPaymentFlow } from "~/hooks/use-split-payment-flow";
import { calculateAmountForSaldo } from "~/utils/basket";
import { priceFormatter } from "~/utils/price-formatter";
import { Button, DialogError } from "~/components";
import { T } from "@repo/transifex";

import { FreedomPayCardPayment } from "./freedompay-card-payment";
import { AdyenCardPayment } from "./adyen-card-payment";

export const PosCardV3Page = () => {
  const { data: till } = useCurrentTill();
  const paymentGatewayProvider = till?.paymentGatewayConfig?.provider;

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");

  const { locale, currency } = useCurrentTillLocalisation();
  const { data: userProducts } = useUserProductsPos();

  const availableBalance = useUserBalance({
    unitAvailableInclVat:
      userProducts?.user?.collectLimit?.unitAvailableInclVat,
    balance: userProducts?.user?.balance
  });

  const unitPriceTotalInclVat = useBasketContext(
    (state) => state.sum.unitPriceTotalInclVat
  );

  const { unitReceived, isActive: isSplitPaymentActive } =
    useSplitPaymentFlow();

  const totalPrice = calculateAmountForSaldo(
    unitPriceTotalInclVat,
    availableBalance
  );
  const totalPriceFormatted = priceFormatter({
    value: totalPrice.payWithOther - unitReceived,
    currency,
    locale
  });

  if (paymentGatewayProvider === "freedompay") {
    return (
      <FreedomPayCardPayment
        orderId={orderId}
        totalPriceFormatted={totalPriceFormatted}
        isSplitPaymentActive={isSplitPaymentActive}
      />
    );
  }

  if (paymentGatewayProvider === "adyen") {
    return (
      <AdyenCardPayment
        orderId={orderId}
        isSplitPaymentActive={isSplitPaymentActive}
        totalPriceFormatted={totalPriceFormatted}
      />
    );
  }

  return (
    <DialogError error={<T _str="Payment provider is not supported" />}>
      <Button
        onClick={() => {
          navigate("/pos/sell");
        }}
        variant="danger"
      >
        <T _str="Close" />
      </Button>
    </DialogError>
  );
};
